/* @flow */

import type { StateData } from "crustate/react";

import { createStateData } from "crustate/react";

import { BrandModel } from "@crossroads/shop-state/brand";
import { MessagesModel } from "@crossroads/shop-state/messages";
import { AllProductsModel } from "@crossroads/shop-state/all-products";
import { OrderModel } from "@crossroads/shop-state/order";
import { PopularModel } from "@crossroads/shop-state/popular";
import { QuoteModel } from "@crossroads/shop-state/quote";
import { RouteModel } from "@crossroads/shop-state/route";
import { SearchModel } from "@crossroads/shop-state/search";

import { CmsPageModel } from "state/cms-page";
import { CmsBlockModel } from "state/cms-block";
import { HomeModel } from "state/home";

export const AllProductsData: StateData<typeof AllProductsModel> =
  createStateData<typeof AllProductsModel>(AllProductsModel);
export const BrandData: StateData<typeof BrandModel> =
  createStateData<typeof BrandModel>(BrandModel);
export const HomeData: StateData<typeof HomeModel> =
  createStateData<typeof HomeModel>(HomeModel);
export const MessagesData: StateData<typeof MessagesModel> =
  createStateData<typeof MessagesModel>(MessagesModel);
export const OrderData: StateData<typeof OrderModel> =
  createStateData<typeof OrderModel>(OrderModel);
export const PopularData: StateData<typeof PopularModel> =
  createStateData<typeof PopularModel>(PopularModel);
export const CmsPageData: StateData<typeof CmsPageModel> =
  createStateData<typeof CmsPageModel>(CmsPageModel);
export const CmsBlockData: StateData<typeof CmsBlockModel> =
  createStateData<typeof CmsBlockModel>(CmsBlockModel);
export const QuoteData: StateData<typeof QuoteModel> =
  createStateData<typeof QuoteModel>(QuoteModel);
export const RouteData: StateData<typeof RouteModel> =
  createStateData<typeof RouteModel>(RouteModel);
export const SearchData: StateData<typeof SearchModel> =
  createStateData<typeof SearchModel>(SearchModel);
